export default __webpack_public_path__ + "static/media/tl.b172f10e.jpg";